// возвращает 5 либо 100, 12, 10

import getGradingSystem from '@/helpers/journal/getGradingSystem';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const useGetCurrentGradeSystem = () => {
    const journalGradingSystemStore = useSelector(store =>
        store.settings.journalGradingSystem);
    const hundredPGradingSystem = useSelector(store =>
        store.settings.hundredPGradingSystem);
    const [journalGradingSystem, setJournalGradingSystem] = useState(
        getGradingSystem(journalGradingSystemStore, hundredPGradingSystem)
    );
    useEffect(() => {
        setJournalGradingSystem(
            getGradingSystem(journalGradingSystemStore, hundredPGradingSystem)
        );
    }, [journalGradingSystemStore, hundredPGradingSystem])

    return journalGradingSystem;
};
